
    import Vue from 'vue';

    export default Vue.extend({
        props: {
            showDialog: Boolean,
        },

        created() {

            this.addPersonToGroupDialogOpen = this.showDialog;
        },
        data() {
            return {
            addPersonToGroup: false,
            addPersonToGroupDialogOpen: false,

            }
        },
        watch: {
            showDialog(val) {
                    this.addPersonToGroupDialogOpen = val;
            },
            addPersonDialogIsOpen(val){
                if(!val){

                    this.$emit('dialog-closed');
                }
            }
        },
        methods: {
            async emitResult(addPersonToGroup: boolean) {
                this.addPersonToGroup = addPersonToGroup;
                this.$emit('dialog-result', this.addPersonToGroup);
            },
            dialogClosed() {
                this.$emit("dialog-closed");
        },
        },
    });
